"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FilePDFOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M28 13h-1V9.84a2 2 0 00-.58-1.41l-5.83-5.84A2 2 0 0019.18 2H7a2 2 0 00-2 2v9H4a2 2 0 00-2 2v9a2 2 0 002 2h1v2a2 2 0 002 2h18a2 2 0 002-2v-2h1a2 2 0 002-2v-9a2 2 0 00-2-2zm-8-8.17L24.16 9H20zM7 4h11v5a2 2 0 002 2h5v2H7zm18 24H7v-2h18zm3-4H4v-9h24z"/><path d="M16.2 16.83h-2.1v5.34h2.1c1.64 0 2.41-1 2.41-2.69s-.75-2.65-2.41-2.65zm-.2 4.31h-.6v-3.28h.6c1 0 1.29.71 1.29 1.65-.01 1.32-.55 1.63-1.29 1.63zM10.56 16.83H8.31v5.34h1.28v-1.65h.95a1.75 1.75 0 001.89-1.84 1.76 1.76 0 00-1.87-1.85zm-.45 2.71h-.52v-1.71h.67a.78.78 0 01.86.85c0 .63-.39.86-1.01.86zM23.93 17.87h-2.26v1.28h2.06v1.01h-2.06v2h-1.29v-5.33h3.55v1.04z"/>';
var FilePDFOutlineSVG = function FilePDFOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.FilePDFOutlineSVG = FilePDFOutlineSVG;
FilePDFOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FilePDFOutlineSVG);
exports.default = _default;